<h1 class="page-title">
  <button class="back-button" [routerLink]="['/configuration']" mat-icon-button>
    <mat-icon>arrow_back</mat-icon>
  </button>
  {{ (brand != undefined) ? brand.name : ""}}
  <button class="edit-button" (click)="editBrand()" mat-icon-button *ngIf="allowBrandEdit">
    <mat-icon>edit</mat-icon>
  </button>
</h1>
<app-settings class="settings-card" [brandId]="brandId" [title]="settingsTitle"></app-settings>
<div class="mt-3">
  <div class="title-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h2 class="page-title">Products</h2>
      <button class="tcb-button" (click)="add()" mat-button *ngIf="allowBrandCreate">
        Add Product
      </button>
    </div>
  </div>
  <mat-card>
    <mat-list>
      <mat-list-item *ngFor="let product of products">
        <a
          [routerLink]="['/configuration/brand/', brandId, 'product', product.productUID]"
          [ngClass]="{'product-active' : product.isActive, 'product-inactive' : !product.isActive}"
          matLine>{{product.code}} - {{product.name}}</a>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item class="badge bg-danger color-white" (click)="delete(product)"
                  *ngIf="allowBrandDelete">Delete
          </button>
        </mat-menu>
      </mat-list-item>
    </mat-list>
  </mat-card>
</div>
